// Ülke adından (TR/EN) bayrak emojisi üretir. Bilinmeyen ülkede null döner.
const COUNTRY_ISO = {
  "amerika birlesik devletleri": "US", amerika: "US", abd: "US", usa: "US", us: "US",
  "united states": "US", "united states of america": "US",
  turkiye: "TR", turkey: "TR", tr: "TR",
  almanya: "DE", germany: "DE", fransa: "FR", france: "FR", italya: "IT", italy: "IT",
  ispanya: "ES", spain: "ES", hollanda: "NL", netherlands: "NL", belcika: "BE", belgium: "BE",
  ingiltere: "GB", "united kingdom": "GB", uk: "GB", "birlesik krallik": "GB", england: "GB",
  avusturya: "AT", austria: "AT", isvicre: "CH", switzerland: "CH", polonya: "PL", poland: "PL",
  cekya: "CZ", czechia: "CZ", "czech republic": "CZ", "cek cumhuriyeti": "CZ",
  portekiz: "PT", portugal: "PT", yunanistan: "GR", greece: "GR",
  isvec: "SE", sweden: "SE", norvec: "NO", norway: "NO", danimarka: "DK", denmark: "DK",
  finlandiya: "FI", finland: "FI", irlanda: "IE", ireland: "IE",
  macaristan: "HU", hungary: "HU", romanya: "RO", romania: "RO",
  bulgaristan: "BG", bulgaria: "BG", hirvatistan: "HR", croatia: "HR",
  slovenya: "SI", slovakya: "SK", litvanya: "LT", letonya: "LV", estonya: "EE",
  luksemburg: "LU", malta: "MT", kibris: "CY", sirbistan: "RS", serbia: "RS",
  ukrayna: "UA", ukraine: "UA", rusya: "RU", russia: "RU",
  cin: "CN", china: "CN", japonya: "JP", japan: "JP",
  "guney kore": "KR", kore: "KR", korea: "KR", "south korea": "KR",
  hindistan: "IN", india: "IN",
  "birlesik arap emirlikleri": "AE", bae: "AE", uae: "AE", dubai: "AE",
  katar: "QA", qatar: "QA", "suudi arabistan": "SA", "saudi arabia": "SA",
  misir: "EG", egypt: "EG", fas: "MA", morocco: "MA", singapur: "SG", singapore: "SG",
  kanada: "CA", canada: "CA", meksika: "MX", mexico: "MX", brezilya: "BR", brazil: "BR",
  arjantin: "AR", argentina: "AR", avustralya: "AU", australia: "AU",
  "yeni zelanda": "NZ", "new zealand": "NZ",
  endonezya: "ID", indonesia: "ID", tayland: "TH", thailand: "TH",
  vietnam: "VN", malezya: "MY", malaysia: "MY",
  azerbaycan: "AZ", azerbaijan: "AZ", gurcistan: "GE", georgia: "GE",
  kazakistan: "KZ", kazakhstan: "KZ", ozbekistan: "UZ", uzbekistan: "UZ",
  iran: "IR", irak: "IQ", iraq: "IQ", israil: "IL", israel: "IL",
  urdun: "JO", jordan: "JO", lubnan: "LB", lebanon: "LB",
  kuveyt: "KW", kuwait: "KW", bahreyn: "BH", bahrain: "BH", umman: "OM", oman: "OM",
  "guney afrika": "ZA", "south africa": "ZA", nijerya: "NG", nigeria: "NG", kenya: "KE",
};

const norm = (s) =>
  (s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i");

export const flagOf = (country) => {
  const code = COUNTRY_ISO[norm(country)];
  if (!code) return null;
  return code.replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
};
